/**
 * Created by Daniel on 11/1/2022
 * ------ maintenance history ------
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../widgets/widgets.module';
import { MapTileDialogComponent } from './map-tile-dialog.component';
import { TamDashboardModule } from '../tam-dashboard/tam-dashboard.module';

@NgModule({
    imports: [
        CommonModule,
        TamDashboardModule,
        WidgetsModule
    ],
    declarations: [
        MapTileDialogComponent,
    ],
    exports: [
        MapTileDialogComponent,
    ]
})
export class MapTileDialogModule { }
